import React, { InputHTMLAttributes } from "react";

import { TransactionTableTabs } from "../../../../enums";
import { useTranslation } from "../../../../hooks";
import { Tab } from "../../../../models";

interface OverviewTabsProps extends InputHTMLAttributes<HTMLInputElement> {
  tabs: Array<Tab>;
  activeTab?: TransactionTableTabs;
  setActiveTab: (num: TransactionTableTabs) => void;
}

export const OverviewTabs: React.FC<OverviewTabsProps> = ({
  tabs,
  activeTab,
  setActiveTab,
  ...restProps
}) => {

  const t = useTranslation();

  return (
    <div className="overview-tab-wrapper">
      {tabs.map((tab) => (
        <div
          key={tab.title}
          onClick={() => setActiveTab(tab.value as TransactionTableTabs)}
          className={`overview-tab-container ${tab.value === activeTab ? "active" : ""}`}
        >
          <span className="tabs-inner-text">{t(tab.title)}</span>
        </div>
      ))}
    </div>
  );
};
